export const socialsdata = [
        {
          title: "Vimeo",
          link: "https://www.vimeo.com/outofshot",
        },
        {
          title: "Youtube",
          link: "https://www.youtube.com/@outofshot",
        },
        {
          title: "Instagram",
          link: "https://www.instagram.com/ronneeswenton_dp",
        },
//        {
//          title: "NOVA",
//          link: "https://www.itsnova.com/ronnee",
//        }, 
        {
          title: "Email",
          link: "mailto:ronnee@whitewizardent.com",
        },
      ];